"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var OPTIONS = [{
  slug: 'no_longer_actively_learning',
  option: 'I am not working on my language fluency any longer'
}, {
  slug: 'prefer_another_method',
  option: 'I have found another learning method that I prefer',
  expanded: 'Which method is working better for you? Why do you prefer it?'
}, {
  slug: 'not_useful_enough',
  option: 'The learning material has not been useful enough',
  expanded: 'How can we improve our learning experience to make it more useful?'
}, {
  slug: 'financial_reasons',
  option: 'My financial situation has changed'
}, {
  slug: 'technical_issues',
  option: 'There have been technical issues',
  expanded: 'We are sorry to hear that.  What has gone wrong?'
}, {
  slug: 'other',
  option: 'Other reasons',
  expanded: 'Can you tell us more?'
}];

// Placeholder until we get cancellation reasons from the backend
var CancellationReasonStore = /*#__PURE__*/function () {
  function CancellationReasonStore() {
    (0, _classCallCheck2["default"])(this, CancellationReasonStore);
  }
  return (0, _createClass2["default"])(CancellationReasonStore, [{
    key: "indexData",
    get: function get() {
      return OPTIONS;
    }
  }]);
}();
var _default = exports["default"] = new CancellationReasonStore();